import { useFormikContext } from 'formik';
import { Box, useEventCallback } from '@mui/material';
import { memo } from 'react';
import { noop } from 'shell/utils/noop';
import { StepButton, StepTypography } from 'shell/components/shared/step-button';
import { StickyDiv } from 'shell/components/shared/sticky-div';
import { PmiButton } from 'shell/components/shared/button';
import { CodeStepButtonsCancellation } from 'cancellations/constants/code-step-buttons-cancellation';
import { CancellationNonResident } from 'cancellations/view-models/cancellation-non-resident';

interface CancellationNonResidentStepButtonsProps {
  onCancel?: () => void;
}

const CancellationNonResidentStepButtonsComponent = ({
  onCancel,
}: CancellationNonResidentStepButtonsProps): React.ReactElement => {
  const formContext = useFormikContext<CancellationNonResident>();

  const registerStepChange = useEventCallback((activeStep: CodeStepButtonsCancellation) => {
    formContext.setValues({ ...formContext.values, activeStep });
  });

  return (
    <StickyDiv>
      <div>
        <div className="pmi-pb-2">
          <StepButton
            visited={
              formContext.values.activeStep === CodeStepButtonsCancellation.datiCancellazione
            }
            active={formContext.values.activeStep === CodeStepButtonsCancellation.datiCancellazione}
            variant="outlined"
            color="cdmBrandThird"
            fullWidth
            onClick={() => registerStepChange(CodeStepButtonsCancellation.datiCancellazione)}
          >
            <StepTypography
              visited={
                formContext.values.activeStep === CodeStepButtonsCancellation.datiCancellazione
              }
              active={
                formContext.values.activeStep === CodeStepButtonsCancellation.datiCancellazione
              }
            >
              DATI CANCELLAZIONE
            </StepTypography>
          </StepButton>
        </div>
        <div className="pmi-pb-2">
          <PmiButton
            variant="outlined"
            color="cdmBrandThird"
            fullWidth
            type="submit"
            // disabled={!formContext.isValid && formContext.submitCount > 0}
          >
            <Box
              sx={{
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
              }}
            >
              CONFERMA
            </Box>
          </PmiButton>
        </div>
      </div>
      <PmiButton variant="contained" color="cdmBrand" fullWidth onClick={onCancel || noop}>
        ANNULLA OPERAZIONE
      </PmiButton>
    </StickyDiv>
  );
};

CancellationNonResidentStepButtonsComponent.displayName =
  'Cancellation non resident buttons component';

const CancellationNonResidentStepButtons = memo(CancellationNonResidentStepButtonsComponent);

export default CancellationNonResidentStepButtons;
